import * as daHelper from '../../../Dialogs/dialogActionsHelper.js';
import { dialogsNames } from '../../../../enums/dialogsNames.js';
import * as sensorProvidersService from '../../../../services/SensorProviders/sensorProvidersService.js';
import Network from 'infrastructure/js/modules/network';

const config = {
  getSubmitMethod: (submitConfigData) => {
    return submitConfigData?.isEditMode ? sensorProvidersService.updateSensorProviderConfig : sensorProvidersService.createSensorProviderConfig;
  },
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG),
  CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG_FETCH_EVENT_PROFILES_READY: 'CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG_FETCH_EVENT_PROFILES_READY',
};

const actions = {
  ...daHelper.getActions(dialogsNames.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG),
  fetchEventProfilesReady(payload) {
    return { type: actionTypes.CREATE_TRUCKS_SENSOR_CONFIGURATION_DIALOG_FETCH_EVENT_PROFILES_READY, payload };
  },
};

export let api = {
  ...daHelper.getApiActions(actions, config),

  show(dispatch, getState) {
    return function (data) {
      if (data) {
        return api
          .fetchDialogData(
            dispatch,
            getState
          )(data)
          .then(() => {
            dispatch(actions.show(data));
          });
      }

      dispatch(actions.show());
    };
  },

  fetchDialogData(dispatch, getState) {
    return function ({ id }) {
      return sensorProvidersService.fetchSensorProviderConfig(id).then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Fetch trucks sensors provider config failed.');
          return { success: false };
        }

        dispatch(actions.fetchDialogDataReady(response.data));
        return { success: true };
      });
    };
  },

  fetchEventProfiles(dispatch, getState) {
    return function (data) {
      dispatch(actions.setBusy(true));
      return sensorProvidersService.fetchEventProfiles(data).then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error('Fetch event profiles failed.');
          dispatch(actions.setBusy(false));
          return { success: false };
        }

        const eventProfiles =
          response.dataList?.map((obj) => {
            return { value: obj.id, label: obj.name, data: obj };
          }) || [];

        dispatch(actions.fetchEventProfilesReady(eventProfiles));
        return { success: true };

      }).catch((error) => {
        console.error('Fetch event profiles failed.', error);
        dispatch(actions.setBusy(false));
        return { success: false };
      });
    };
  },
};

export let jsxActions = {
  ...daHelper.getJsxActions(api),

  fetchEventProfiles: function (data) {
    return function (dispatch, getState) {
      return api.fetchEventProfiles(dispatch, getState)(data);
    };
  },
};
